module.exports = __webpack_public_path__ + "img/work-down.fef438aa.png";